import { Moon, Sun } from 'lucide-react';
import { useAccessibility } from '@/hooks/useAccessibility';
import { cn } from '@/lib/utils';

interface DashboardThemeToggleProps {
  className?: string;
  showLabel?: boolean;
}

/** Usa o mesmo localStorage `darkMode` do site principal */
export function DashboardThemeToggle({
  className,
  showLabel = false,
}: DashboardThemeToggleProps) {
  const { isDarkMode, toggleDarkMode } = useAccessibility();

  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className={cn(
        'inline-flex items-center gap-2 rounded-lg px-2.5 py-2 text-muted-foreground hover:text-foreground hover:bg-background transition-colors',
        className
      )}
      aria-label={isDarkMode ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      {isDarkMode ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      {showLabel && (
        <span className="text-xs font-medium">
          {isDarkMode ? 'Claro' : 'Escuro'}
        </span>
      )}
    </button>
  );
}
